<template>
  <div>
    <List
      v-bind:headers="headers"
      v-bind:formview="null"
      v-bind:table="table"
      v-bind:default_limit="'1000'"
      v-bind:addbutton="false"
      v-bind:default_sort="'created_at'"
      v-bind:default_sort_typ="'DESC'"
      v-bind:extension="extension"
      v-bind:export_csv="false"
    ></List>
  </div>
</template>

<script>
import List from '@/components/ListDefault'

export default {
  name: "ActivityLogViewer",

  components: {
    List,
  },

  data () {
    return {
      table: 'activity_log',
    }
  },

  computed: {
    headers () {
      return [
        { text: 'ID', value: 'id' },
        { text: 'Benutzer', value: 'username' },
        { text: 'Aktion', value: 'action' },
        { text: 'Tabelle', value: 'table_name' },
        { text: 'Datensatz ID', value: 'record_id' },
        { text: 'Beschreibung', value: 'description' },
        { text: 'Datum', value: 'created_at' },
      ]
    },

    extension () {
      return ''
    }
  },
}
</script>

<style scoped>

</style>